import {Message} from "view-design";
import {baseUrl, indexUrl} from "../http/baseUrl";
import axios from "axios";
import $ from "jquery";


//全局警告提示
function warnToast(content) {
  Message['warning']({
    background: true,
    content: content
  })
}

//全局成功提示
function successToast(content) {
  Message['success']({
    background: true,
    content: content
  })
}

//全局错误提示
function errorToast(content) {
  Message['error']({
    background: true,
    content: content
  })
}

//全局提示信息
function infoToast(content) {
  Message['info']({
    background: true,
    content: content
  })
}

//验证短信验证码为四位纯数字
function isVerifyCode(code) {
  const reg = /^\d{6}$/;
  return reg.test(code);

}

//验证手机号为11位纯数字
function isPhoneNumber(phone) {
  const reg = /^\d{11}$/;
  return reg.test(phone);
}

//验证密码为8-16位数字字母组合
function isCorrectPassword(password) {
  const pwdReg = /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{8,16}$/;
  return pwdReg.test(password)
}

//数字小鱼9999显示数字大于显示xx.x万
function formatNum(num) {
  if (!num || num === 0) {
    return 0;
  }
  return num > 9999 ? (num / 10000).toFixed(2) + '万' : num
}

//打开全新的页面
function openNewWindow(url) {
  window.open(url, '_blank');
}

//请求时有的接口可以允许同时请求两次
function allowSameRequest(config) {
  const allowUrlA = `${indexUrl}/v1/template/index`;//首页请求
  return config.url === allowUrlA;
}

function getValueByPropertyStr(ob, str) {
  var result = ''
  const propertys = str.split('.')
  result = ob
  propertys.forEach(item => {
    result = result[item]
  })
  return result
}

// 根据规则校验数据返回错误提示
function validForm(model, rules, returnAllErr) {
  let valid = true
  const error = []
  for (const property in rules) {
    const value = getValueByPropertyStr(model, property)
    const rule = rules[property]
    rule.some(item => {
      if (item.validator && !item.validator(value)) {
        valid = false
        error.push(item.msg)
      }
      return !valid
    })
    if (returnAllErr && valid) {
      break
    }
  }
  return error
}

//数字滚动
function countjs(numData = [], size = 0) {
  // <div :id="`count${i}`" :num="num">0</div>
  let options = {
    lastNumber: 6666,
    duration: 4000,
    easing: 'swing',  //慢快慢
  }
  size = size > 0 ? size : numData.length
  this.$nextTick(() => {
    setTimeout(() => {
      for (let i = 0; i < size; i++) {
        const num = $('#count' + i).attr('num')
        countsetting($('#count' + i), options, num)
      }
    }, 1000)
  });
}

function countsetting(obj, options, lastNumber) {
  var defaults = {
    lastNumber: 100,
    duration: 1000,
    easing: 'swing'  //swing(默认 : 缓冲 : 慢快慢)  linear(匀速的)
  };
  var opts = $.extend({}, defaults, options);
  obj.animate({
    num: "numberRock",
    // width : 300,
    // height : 300,
  }, {
    duration: opts.duration,
    speed: 500,
    easing: opts.easing,
    complete: function () {
      // console.log("success");
      //处理数字有小数的问题
      obj.html(lastNumber)
    },
    step: function (a, b) {  //可以检测我们定时器的每一次变化
      //console.log(a);
      // console.log(b.pos);   //运动过程中的比例值(0~1)
      lastNumber = lastNumber || opts.lastNumber
      obj.html((b.pos * lastNumber).toFixed(1));
    }
  });
}


/**
 * @param {Function} func
 * @param {number} wait
 * @param {boolean} immediate
 * @return {*}
 */
function debounce(func, wait, immediate) {
  let timeout, args, context, timestamp, result

  const later = function() {
    // 据上一次触发时间间隔
    const last = +new Date() - timestamp

    // 上次被包装函数被调用时间间隔 last 小于设定时间间隔 wait
    if (last < wait && last > 0) {
      timeout = setTimeout(later, wait - last)
    } else {
      timeout = null
      // 如果设定为immediate===true，因为开始边界已经调用过了此处无需调用
      if (!immediate) {
        result = func.apply(context, args)
        if (!timeout) context = args = null
      }
    }
  }

  return function(...args) {
    context = this
    timestamp = +new Date()
    const callNow = immediate && !timeout
    // 如果延时不存在，重新设定延时
    if (!timeout) timeout = setTimeout(later, wait)
    if (callNow) {
      result = func.apply(context, args)
      context = args = null
    }

    return result
  }
}

/**
 * 如果target(也就是FirstOBJ[key])存在，
 * 且是对象的话再去调用deepObjectMerge，
 * 否则就是FirstOBJ[key]里面没这个对象，需要与SecondOBJ[key]合并
 */
function deepObjectMerge(FirstOBJ, SecondOBJ) { // 深度合并对象
  for (var key in SecondOBJ) {
    FirstOBJ[key] = FirstOBJ[key] && (FirstOBJ[key].constructor == Array || FirstOBJ[key].constructor == Object) ?
      deepObjectMerge(FirstOBJ[key], SecondOBJ[key]) : FirstOBJ[key] = SecondOBJ[key];
  }
  return FirstOBJ;
}


export {
  warnToast,
  isVerifyCode,
  isPhoneNumber,
  isCorrectPassword,
  successToast,
  errorToast,
  infoToast,
  formatNum,
  openNewWindow,
  allowSameRequest,
  validForm,
  countjs,
  debounce,
  deepObjectMerge
}



// WEBPACK FOOTER //
// ./src/plugins/tools/util.js